(() => {
  'use strict';
  const labels = JSON.parse(document.getElementById('plainbuy-ui-strings')?.textContent || '{}');
  const text = key => labels[key] || key;
  const scrollToElement = element => {
    element?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    element?.querySelector('input,select,button')?.focus({ preventScroll: true });
  };
  const setText = (element, value) => { if (element.textContent !== value) element.textContent = value; };
  function initSizeSources() {
    document.querySelectorAll('[data-mt-size-source]').forEach(source => {
      if (source.dataset.pbReady) return;
      source.dataset.pbReady = 'true';
      const chart = [...source.content.querySelectorAll('img')].find(image => /size\s*(guide|chart)|measurements|尺码/i.test(image.alt || ''));
      const image = source.parentElement.querySelector('[data-mt-size-image]');
      if (!chart || !image) return;
      const url = chart.getAttribute('src') || chart.getAttribute('data-src');
      if (!url) return;
      try {
        const safe = new URL(url, location.href);
        if (!['https:', 'http:'].includes(safe.protocol)) return;
        image.src = safe.href;
        image.hidden = false;
        const empty = source.parentElement.querySelector('[data-mt-size-empty]');
        if (empty) empty.hidden = true;
      } catch {}
    });
  }
  function initCards() {
    document.querySelectorAll('.product-card-wrapper,.zm-card').forEach(card => {
      if (card.dataset.mtReady) return;
      card.dataset.mtReady = 'true';
      const images = card.querySelectorAll('.card__media img,.zm-card__image img');
      const secondary = images[1];
      if (!images[0] || !secondary || /size\s*(chart|guide)|measurement/i.test(secondary.alt || '')) return;
      const wrap = card.querySelector('.card__inner,.zm-card__image');
      if (!wrap) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'mt-gallery-toggle';
      button.innerHTML = '<svg viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="4" y="8" width="15" height="16" rx="2"/><path d="M10 4h12a2 2 0 0 1 2 2v13M8 19l4-5 4 5"/></svg>';
      button.setAttribute('aria-label', text('another_photo'));
      button.setAttribute('aria-pressed', 'false');
      button.addEventListener('click', event => {
        event.preventDefault();event.stopPropagation();
        const active = button.getAttribute('aria-pressed') !== 'true';
        button.setAttribute('aria-pressed', String(active));
        button.setAttribute('aria-label', text(active ? 'first_photo' : 'another_photo'));
        card.classList.toggle('mt-other-view', active);
      });
      if (wrap.tagName === 'A') { const frame = document.createElement('div');frame.className = 'pb-card-media';wrap.before(frame);frame.append(wrap, button); }
      else wrap.append(button);
    });
  }
  function selected(box) {
    if (!box) return true;
    const groups = [...box.querySelectorAll('fieldset')];
    if (groups.length) return groups.every(group => group.querySelector('input:checked'));
    return [...box.querySelectorAll('select')].every(select => select.value);
  }
  const nativeBuy = () => document.querySelector('product-info[id^="MainProduct"] product-form button[name="add"]');
  const optionBox = () => document.querySelector('product-info[id^="MainProduct"] variant-selects');
  function initSticky() {
    if (!nativeBuy() || document.querySelector('.mt-sticky')) return;
    document.body.classList.add('mt-product-page');
    const bar = document.createElement('div');bar.className = 'mt-sticky';bar.hidden = true;
    const copy = document.createElement('div');copy.className = 'mt-sticky-copy';
    const name = document.createElement('span');const price = document.createElement('strong');copy.append(name, price);
    const action = document.createElement('button');action.type = 'button';bar.append(copy, action);document.body.append(bar);
    let pending = false;
    const refresh = () => {
      pending = false;
      const current = nativeBuy();
      if (!current) { bar.hidden = true; return; }
      const info = current.closest('product-info');const rect = current.getBoundingClientRect();
      const visible = rect.bottom > 0 && rect.top < innerHeight;const ready = selected(optionBox());
      const busy = current.classList.contains('loading') || current.getAttribute('aria-busy') === 'true';
      const unavailable = current.disabled || current.getAttribute('aria-disabled') === 'true';
      const p = info.querySelector('.price--on-sale .price-item--sale,.price:not(.price--on-sale) .price-item--regular');
      setText(name, info.querySelector('.product__title h1')?.textContent.trim() || '');setText(price, p?.textContent.trim() || '');
      const nativeLabel = current.querySelector('span')?.textContent.trim();
      setText(action, busy ? text('adding') : !ready ? text('choose') : unavailable ? nativeLabel || text('unavailable') : text('add'));
      action.disabled = busy || (ready && unavailable);action.setAttribute('aria-busy', String(busy));
      bar.hidden = visible || scrollY < 250 || innerWidth >= 990 || !!document.querySelector('dialog[open],cart-drawer.active,.drawer.active');
    };
    const queue = () => { if (!pending) { pending = true;requestAnimationFrame(refresh); } };
    action.addEventListener('click', () => {
      const current = nativeBuy();if (!current) return;
      if (!selected(optionBox())) { scrollToElement(optionBox() || current);return; }
      if (current.disabled || current.getAttribute('aria-disabled') === 'true' || current.classList.contains('loading')) return;
      current.click();
    });
    document.addEventListener('submit', event => {
      if (!event.target.matches('product-info[id^="MainProduct"] form[data-type="add-to-cart-form"]') || selected(optionBox())) return;
      event.preventDefault();event.stopImmediatePropagation();scrollToElement(optionBox());
    }, true);
    window.addEventListener('scroll', queue, { passive: true });window.addEventListener('resize', queue, { passive: true });
    document.addEventListener('change', queue);document.addEventListener('click', queue);document.addEventListener('close', queue, true);
    new MutationObserver(queue).observe(document.querySelector('#MainContent') || document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'class'] });
    refresh();
  }
  if (!customElements.get('plainbuy-load-more')) {
    customElements.define('plainbuy-load-more', class extends HTMLElement {
      connectedCallback() {
        this.grid = this.closest('#ProductGridContainer')?.querySelector('#product-grid');
        this.action = this.querySelector('[data-pb-load-button]');this.status = this.querySelector('[data-pb-load-status]');
        this.busy = false;this.failed = false;this.cancelled = false;this.loaded = new Set();
        this.onClick = event => { if (event.target.closest('[data-pb-load-button]')) { event.preventDefault();this.failed = false;this.load(); } };
        this.onFilter = () => { this.cancelled = true;this.controller?.abort();this.observer?.disconnect(); };
        this.addEventListener('click', this.onClick);document.addEventListener('plainbuy:filters-start', this.onFilter);
        if ('IntersectionObserver' in window && this.dataset.nextUrl) {
          this.observer = new IntersectionObserver(entries => { if (entries.some(entry => entry.isIntersecting) && !this.failed) this.load(); }, { rootMargin: '300px' });
          this.observer.observe(this);
        }
      }
      disconnectedCallback() {
        this.controller?.abort();this.observer?.disconnect();document.removeEventListener('plainbuy:filters-start', this.onFilter);this.removeEventListener('click', this.onClick);
      }
      async load() {
        if (!this.grid || this.busy || this.cancelled || !this.dataset.nextUrl) return;
        const target = new URL(this.dataset.nextUrl, location.href);
        if (target.origin !== location.origin || this.loaded.has(target.href)) return;
        const context = location.pathname + location.search;target.searchParams.set('section_id', this.dataset.sectionId);
        this.controller = new AbortController();this.busy = true;this.setAttribute('aria-busy', 'true');this.grid.setAttribute('aria-busy', 'true');this.action?.setAttribute('aria-disabled', 'true');setText(this.status, text('load_busy'));
        try {
          const response = await fetch(target.href, { signal: this.controller.signal });
          if (!response.ok) throw new Error('Collection request failed');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (!this.isConnected || this.cancelled || context !== location.pathname + location.search) return;
          const incoming = html.querySelector('#product-grid');const next = html.querySelector('plainbuy-load-more');
          if (!incoming || !next) throw new Error('Collection response incomplete');
          const seen = new Set([...this.grid.querySelectorAll('[data-pb-product-id]')].map(item => item.dataset.pbProductId));
          for (const item of [...incoming.children]) {
            if (seen.has(item.dataset.pbProductId)) continue;
            seen.add(item.dataset.pbProductId);item.classList.add('scroll-trigger--cancel');item.querySelectorAll('img').forEach(image => { image.loading = 'lazy'; });this.grid.append(item);
          }
          this.loaded.add(new URL(this.dataset.nextUrl, location.href).href);this.dataset.nextUrl = next.dataset.nextUrl || '';this.failed = false;
          if (this.action) { this.action.hidden = !this.dataset.nextUrl;if (this.dataset.nextUrl) this.action.href = this.dataset.nextUrl;setText(this.action, text('load_more')); }
          setText(this.status, text(this.dataset.nextUrl ? 'load_ready' : 'load_done'));if (!this.dataset.nextUrl) this.observer?.disconnect();initCards();
        } catch (error) {
          if (error.name !== 'AbortError' && this.isConnected && !this.cancelled) { this.failed = true;setText(this.status, text('load_error'));if (this.action) { this.action.hidden = false;setText(this.action, text('load_retry')); } }
        } finally { this.busy = false;this.removeAttribute('aria-busy');this.grid.removeAttribute('aria-busy');this.action?.removeAttribute('aria-disabled'); }
      }
    });
  }
  function initHeader() {
    const header = document.querySelector('.zm-header');if (!header || header.dataset.pbReady) return;header.dataset.pbReady = 'true';
    const holder = header.parentElement;let anchor = scrollY;let boundary = holder.getBoundingClientRect().bottom + scrollY;let queued = false;
    const update = () => {
      queued = false;const current = Math.max(scrollY, 0);
      if (innerWidth >= 990 || current < boundary) { header.classList.remove('pb-header-floating', 'pb-header-hidden');holder.style.minHeight = '';anchor = current;return; }
      if (!header.classList.contains('pb-header-floating')) { holder.style.minHeight = holder.offsetHeight + 'px';header.classList.add('pb-header-floating', 'pb-header-hidden'); }
      if (Math.abs(current - anchor) > 10) { header.classList.toggle('pb-header-hidden', current > anchor && !header.querySelector('details[open]'));anchor = current; }
    };
    window.addEventListener('scroll', () => { if (!queued) { queued = true;requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', () => { header.classList.remove('pb-header-floating', 'pb-header-hidden');holder.style.minHeight = '';boundary = holder.getBoundingClientRect().bottom + scrollY;anchor = scrollY;update(); });
  }
  document.addEventListener('click', event => { if (event.target.closest('[data-pb-size-open]')) document.querySelector('[data-zm-open^="zm-size-guide-"]')?.click(); });
  function init() { initSizeSources();initCards();initSticky();initHeader(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);else init();
  let scheduled = false;
  new MutationObserver(() => { if (!scheduled) { scheduled = true;requestAnimationFrame(() => { scheduled = false;init(); }); } }).observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', init);
})();
